// extracted by mini-css-extract-plugin
export default {"container":"mz-z","dimension":"nz-z","dimensionLabels":"oz-z"};